import { Link } from "react-router-dom";
import { ArrowRight, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteNav from "@/components/SiteNav";
import SiteFooter from "@/components/SiteFooter";
import { TECH_STACK } from "@/lib/biohackerBrand";

const CATEGORIES = [
  { key: "performance",       label: "Performance Technology",        tone: "#F59E0B" },
  { key: "human_performance", label: "Human Performance & Wearables", tone: "#22D3EE" },
  { key: "biomechanics",      label: "Biomechanics & Vision",         tone: "#A78BFA" },
  { key: "medical",           label: "Medical & Wellness",            tone: "#10B981" },
  { key: "coach_inputs",      label: "Coach Inputs",                  tone: "#D90429" },
];

export default function Technology() {
  return (
    <div className="min-h-screen bg-[#050810] text-white" data-testid="technology-page">
      <SiteNav />
      <section className="pt-32 pb-14 border-b border-white/8 max-w-7xl mx-auto px-6">
        <div className="text-[10px] tracking-[0.4em] uppercase font-bold text-fuchsia-300/80 mb-3">Your Technology Stack</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.05]">
          BioHacker Sports™ works with<br/>
          <span className="text-white/50">the technology you already own.</span>
        </h1>
        <p className="mt-6 text-white/70 max-w-2xl">
          Hardware-agnostic by design. Every device streams into the
          {" "}BioHacker Intelligence Cloud™{" "}
          to create one continuously-evolving Athlete Intelligence Profile™.
        </p>
      </section>

      <section className="py-14 max-w-7xl mx-auto px-6 space-y-8">
        {CATEGORIES.map((cat) => (
          <div key={cat.key} className="ink-card rounded-2xl p-8" data-testid={`tech-cat-${cat.key}`}>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-2 w-2 rounded-full" style={{ background: cat.tone }} />
              <div className="font-display font-black text-white text-xl">{cat.label}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              {(TECH_STACK[cat.key] || []).map((vendor) => (
                <span key={vendor} className="text-[11px] font-bold uppercase tracking-[0.12em] px-3 py-1.5 rounded-full border border-white/12 text-white/75">
                  {vendor}
                </span>
              ))}
            </div>
          </div>
        ))}
      </section>

      <section className="py-16 border-t border-white/8 text-center">
        <Cpu className="h-8 w-8 mx-auto text-fuchsia-400 mb-3" />
        <h2 className="font-display font-black text-3xl text-white tracking-tight">Bring your own devices.<br/><span className="text-white/50">We&apos;re the intelligence layer.</span></h2>
        <div className="mt-6">
          <Link to="/request-demo">
            <Button size="lg" className="text-white font-bold text-sm px-6 py-6" style={{ backgroundColor: "var(--brand-secondary)" }}>
              Talk to an integrations engineer <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
